module.exports = __webpack_public_path__ + "static/img/77-3.c032444.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/77-3.jpg
// module id = J4qc
// module chunks = 0